import { useEffect, useState } from 'react'
import { getImageUrl } from 'services/assets'
import { trackEvent } from 'utils/tracking'
import { setSnackBar } from 'state/ui'
import { useAppDispatch } from 'utils/custom-hooks/useTypedReduxStore'
import Lightbox from 'yet-another-react-lightbox'
import 'yet-another-react-lightbox/styles.css'
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails'
import Download from 'yet-another-react-lightbox/plugins/download'
import 'yet-another-react-lightbox/plugins/thumbnails.css'

type ImageUrl = {
  src: string
}

const GrossTareImagesLightbox = ({ lightboxOpen, lightboxImages, onClose }) => {
  const [imageUrls, setImageUrls] = useState<ImageUrl[]>([])
  const dispatch = useAppDispatch()

  const handleS3Error = error => {
    const errorMsg = error?.data?.error || 'There was an error getting an image'
    trackEvent({ eventName: 'GET_S3_IMAGE_ERROR', errorMsg })
    dispatch(
      setSnackBar({
        snackbarType: 'error',
        snackbarMessage: errorMsg,
      }),
    )
  }

  useEffect(() => {
    const fetchImageSignedUrls = async images => {
      try {
        const urls = await Promise.all(images.map(image => getImageUrl(image)))
        setImageUrls(urls.map(url => ({ src: url })))
      } catch (error) {
        handleS3Error(error)
      }
    }

    if (lightboxImages && lightboxOpen) {
      fetchImageSignedUrls(lightboxImages)
    }
  }, [lightboxImages, lightboxOpen])

  return <Lightbox open={lightboxOpen} close={onClose} slides={imageUrls} plugins={[Thumbnails, Download]} />
}

export default GrossTareImagesLightbox
